"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultProvider = void 0;
exports.defaultProvider = new URL('https://nfid.one/wallet/request-accounts');
